module.exports = __webpack_public_path__ + "static/hobby-infra-4af928693462ce10154e6d146b1dde95.png";